module.exports = __webpack_public_path__ + "static/2-b70339eb5926ec180582cb25b1e303fc.png";